export default {
      id: "icon-mobile-menu-pro-usage",
      viewBox: "0 0 19 19",
      url: "../icon/" + "icons.svg#icon-mobile-menu-pro-usage",
      toString: function () {
        return this.url;
      }
    }